import React from "react";
import { useSpringValue } from "../../lib/motion";

// Proof case for the AEON spring system (spring-feel plan, 2026-10-28).
// Previously this component animated with a fixed 900ms cubic ease that
// restarted from its stored start value whenever the target changed
// mid-flight. Now the displayed value is a damped spring (snappy preset:
// fast, critically damped, no overshoot on data) whose retarget keeps the
// current position AND velocity — a fast tape bends, never restarts.
// First render shows the value as-is (the spring starts at its target);
// reduced motion jumps instantly (handled inside useSpringValue).
export default function AnimatedNumber({
  value,
  prefix = "",
  suffix = "",
  decimals = 0,
  className = "",
}) {
  const target = Number(value) || 0;
  const display = useSpringValue(target, "snappy");

  const formatted = display.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return (
    <span className={`arena-counter ${className}`}>
      {prefix}{formatted}{suffix}
    </span>
  );
}
